<template lang="pug">
  //p RECTANGLE {{bounds}}
</template>
<script>
export default {
  props:{
    parentContainer:{
      required:true,
      type:Object
    },
    bounds:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    lineWidth:{
      type:Number,
      default:5
    },
    fill:{
      type:Boolean,
      default:true
    },
    lineColor:{
      type:Number,
      default:0xff00ff
    },
    fillColor:{
      type:Number,
      default:0xff00ff
    },
    alpha: {
      type: Number,
      default: 0.3
    },
    cacheAsBitmap:{
      type:Boolean,
      default:false
    }
  },
  beforeDestroy() {
    this.graphics.parent.removeChild(this.graphics);
  },
  mounted() {
    this.graphics = new PIXI.Graphics();

    this.update();

    this.parentContainer.addChild(this.graphics);
    this.renderTools.addToRunBatch(this.update.bind(this));

  },
  methods:{
    update() {
      if (this.cacheAsBitmap) {
        this.graphics.cacheAsBitmap= false;
      }
      const x1 = this.renderTools.worldToScreen_x(this.bounds.x1);
      const y1 = this.renderTools.worldToScreen_y(this.bounds.y1);
      const x2 = this.renderTools.worldToScreen_x(this.bounds.x2 - this.bounds.x1);
      const y2 = this.renderTools.worldToScreen_y(this.bounds.y2 - this.bounds.y1);

      this.graphics.clear();
      this.graphics.lineStyle(this.lineWidth, this.lineColor);
      if (this.fill) {
        this.graphics.beginFill(this.fillColor);
      }
      this.graphics.drawRect(x1, y1, x2, y2);
      if (this.fill) {
        this.graphics.endFill();
      }
      this.graphics.alpha = this.alpha;

      if (this.cacheAsBitmap) {
        this.renderTools.addToRunBatch( () => {
          this.graphics.cacheAsBitmap = true;
        });
      }
    }
  },
  watch:{
    'bounds.x1'() {
      this.update();
    },
    'bounds.x2'() {
      this.update();
    },
    'bounds.y1'() {
      this.update();
    },
    'bounds.y2'() {
      this.update();
    }
  }
}
</script>
